<template>
    <span class="pn-score" :class="{ healthy: isHealthy, hazard: pnHazard }">
        {{ pnText }}
    </span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'PnScore',
    props: {
        well: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getPnCount: 'timelapse/getPnCount',
            getPnText: 'timelapse/getPnText',
            getPnHazard: 'timelapse/getPnHazard'
        }),
        pnCount() {
            return this.getPnCount(this.well)
        },
        noPnCount() {
            return this.pnCount === null
        },
        pnText() {
            return this.getPnText(this.well)
        },
        pnHazard() {
            return this.getPnHazard(this.well)
        },
        isHealthy() {
            return !this.noPnCount && !this.pnHazard
        }
    }
}
</script>

<style lang="scss" scoped>
.pn-score {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11pt;
    font-weight: 600;
    background-color: $dark-4;
    border-radius: $border-radius;

    &.healthy {
        color: $blue;
        border: solid 1px $blue;
    }

    &.hazard {
        color: $red;
        border: solid 1px $red;
    }
}
</style>
